import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div
      className="d-flex align-items-center justify-content-center"
      style={{
        minHeight: "80vh",
        background: "linear-gradient(120deg, #f7f8ff 60%, #f8e0f5 100%)",
      }}
    >
      <div className="text-center px-4">
        <div
          className="mb-4"
          style={{
            fontSize: "8rem",
            fontWeight: "bold",
            background: "linear-gradient(90deg, #6B46C1, #D53F8C)",
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            color: "transparent",
            lineHeight: 1,
          }}
        >
          404
        </div>
        <h1
          className="mb-3 fw-bold"
          style={{
            fontFamily: "'Poppins', sans-serif",
            fontSize: "2.5rem",
            color: "#23284b",
          }}
        >
          Page Not Found
        </h1>
        <p
          className="mb-4 fs-5"
          style={{ color: "#344476", maxWidth: "500px", margin: "0 auto" }}
        >
          Oops! The page you're looking for doesn't exist. It might have been
          moved, deleted, or the URL might be incorrect.
        </p>
        <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center">
          <Link
            to="/"
            className="btn btn-lg rounded-pill px-5 py-3 fw-bold text-white"
            style={{
              background: "linear-gradient(90deg, #6B46C1, #D53F8C)",
              border: "none",
              boxShadow: "0 4px 16px rgba(107, 70, 193, 0.3)",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = "translateY(-2px)";
              e.target.style.boxShadow = "0 6px 24px rgba(107, 70, 193, 0.4)";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "0 4px 16px rgba(107, 70, 193, 0.3)";
            }}
          >
            Go to Homepage
          </Link>
          <Link
            to="/contact"
            className="btn btn-lg rounded-pill px-5 py-3 fw-bold"
            style={{
              background: "#fff",
              color: "#6B46C1",
              border: "2px solid #6B46C1",
              boxShadow: "0 4px 16px rgba(107, 70, 193, 0.2)",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.background = "#6B46C1";
              e.target.style.color = "#fff";
              e.target.style.transform = "translateY(-2px)";
              e.target.style.boxShadow = "0 6px 24px rgba(107, 70, 193, 0.4)";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "#fff";
              e.target.style.color = "#6B46C1";
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "0 4px 16px rgba(107, 70, 193, 0.2)";
            }}
          >
            Contact Us
          </Link>
        </div>
        <div className="mt-5">
          <p className="text-muted mb-2">You might be looking for:</p>
          <div className="d-flex flex-wrap gap-2 justify-content-center">
            <Link
              to="/about"
              className="text-decoration-none"
              style={{ color: "#6B46C1" }}
            >
              About Us
            </Link>
            <span className="text-muted">•</span>
            <Link
              to="/services"
              className="text-decoration-none"
              style={{ color: "#6B46C1" }}
            >
              Services
            </Link>
            <span className="text-muted">•</span>
            <Link
              to="/refund-status"
              className="text-decoration-none"
              style={{ color: "#6B46C1" }}
            >
              Fund Info
            </Link>
            <span className="text-muted">•</span>
            <Link
              to="/contact"
              className="text-decoration-none"
              style={{ color: "#6B46C1" }}
            >
              Contact
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

